import { useCallback } from 'react';
import type React from 'react';

import { Button } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';
import { Link } from '@change-corgi/core-react/router';

import { useCampaignTracking } from '#src/app/shared/hooks/campaignTracking';

type Props = {
	petitionId: string;
	slug: string;
};

export const ViewAllComments: React.FC<Props> = ({ petitionId, slug }) => {
	const { track } = useCampaignTracking();

	const trackViewAllClick = useCallback(() => {
		track('petition_gamma_supporter_comments_view_all_click', { petition_id: petitionId });
	}, [petitionId, track]);

	return (
		<div className="flex justify-center">
			<Button
				as={Link}
				to={`/p/${slug}/feed`}
				data-testid="supporter-comments-view-all"
				data-qa="supporter-comments-view-all"
				variant="secondary"
				onClick={trackViewAllClick}
				className="w-full md:w-auto"
			>
				<Translate value="corgi.petition_gamma.comments.view_all" />
			</Button>
		</div>
	);
};
